import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule }  from '@angular/router';
import { DataTableModule } from "angular2-datatable";
import { ShareModule} from "../share.module";
//import { DataFilterPipe }   from "../data-filter.pipe";
//import { DataUnitFilterPipe }   from "../data-unit-filter.pipe";
//import { DataLevelFilterPipe }   from "../data-level-filter.pipe";
//import { DataTutorFilterPipe }   from "../data-tutor-filter.pipe";
//import { DataEmailFilterPipe }   from "../data-email-filter.pipe";
//import { DataGroupFilterPipe }   from "../data-group-filter.pipe";

/*
 * Components
 */
import { MemberComponent } from './member.component';
import { DashboardComponent } from './dashboard.component';
import { ProfileComponent } from './profile.component';
import { JourneyComponent } from './journey.component';
import { JourneyChapterComponent } from './journey-chapter.component';
import { SpritJoyComponent } from './spritjoy.component';
import { SpritJoyDayComponent } from './spritjoy-day.component';
import { JourneyRecComponent } from './journey-rec.component';
import { SpritJoyRecComponent } from './spritjoy-rec.component';

/*
* Routning
*/
import { MemberRoutingModule }     from './member-routing.module';

/*
* Service
*/
import { MemberService } from './member.service';


@NgModule({
  declarations: [
    MemberComponent,
    DashboardComponent,
    ProfileComponent,
    JourneyComponent,
    JourneyChapterComponent,
    SpritJoyComponent,
    SpritJoyDayComponent,
    JourneyRecComponent,
    SpritJoyRecComponent,
    //DataFilterPipe,
    //DataEmailFilterPipe,
    //DataTutorFilterPipe,
    //DataLevelFilterPipe,
    //DataUnitFilterPipe,
    //DataGroupFilterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DataTableModule,
    ShareModule,
    MemberRoutingModule
  ],
  providers: [MemberService]
})

export class MemberModule { }



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/member.module.ts